import { t } from "i18next";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Dimmer, Icon, Modal } from "semantic-ui-react";
import { closeModal } from "../../redux/Modals/ModalActions";
import { AppOutlineButton } from "../UI/CustomButtons";
import "./PreLaunchSignupSuccess.css";

const actions = {
  closeModal,
};

const mapStateToProps = (state) => ({
  theme: state.theme,
});

class PreLaunchSignupSuccess extends Component {
  render() {
    const { closeModal, theme } = this.props;
    return (
      <div>
        <Dimmer />
        <Modal
          size="tiny"
          style={{ KhtmlBoxAlign: "center" }}
          open={true}
          closeOnEscape={false}
          closeOnDimmerClick={false}
          centered
        >
          <Modal.Content>
            <div className="success-modal-content">
              <div
                className="checkmark-circle"
                style={{ backgroundColor: theme.primaryColor }}
              >
                <Icon name="check" size="large" />
              </div>
              <ModalContent />
              <AppOutlineButton inverted onClick={closeModal}>
                Okej
              </AppOutlineButton>
            </div>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

function ModalContent() {
  return (
    <>
      <h2 className="success-text">{t("pre_launch_thank_you")}</h2>
      <p className="success-subtext">{t("pre_launch_success_registered")}</p>
    </>
  );
}

export default connect(mapStateToProps, actions)(PreLaunchSignupSuccess);
export const MODAL_PRE_LAUNCH_SIGNUP_SUCCESS = "PreLaunchSignupSuccess";
